import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mantine/core";
import { useState } from "react";

import { ConfirmationPopover } from "@/components/ui/confirmation-popover/confirmation-popover";

interface ActionButtonProps {
  hidden?: boolean;
  isDraft?: boolean;
  isInactive?: boolean;
  isReInviteLoading?: boolean;
  onDeactivate?: () => void;
  onReInvite?: () => void;
  onRemoveDraft?: () => void;
}

export const ActionButton = ({
  hidden,
  isDraft,
  isInactive,
  isReInviteLoading,
  onDeactivate,
  onReInvite,
  onRemoveDraft,
}: ActionButtonProps) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  if (hidden) {
    return null;
  }

  if (isInactive) {
    return (
      <Button
        className="uppercase text-xs font-semibold tracking-wider"
        variant="transparent"
        c="purple.5"
        p={0}
        size="compact-sm"
        loading={isReInviteLoading}
        onClick={() => onReInvite?.()}
      >
        Re-invite
      </Button>
    );
  }

  const handleClick = () => {
    if (isDraft) {
      onRemoveDraft?.();
    } else {
      setIsConfirmOpen(true);
    }
  };

  const button = (
    <Button
      className="gap-1.5 uppercase text-xs font-semibold tracking-wider"
      variant="transparent"
      c="red.3"
      p={0}
      size="compact-sm"
      onClick={handleClick}
      rightSection={<FontAwesomeIcon icon={faXmark} size="sm" />}
    >
      Remove
    </Button>
  );

  if (isDraft) {
    return button;
  }

  return (
    <ConfirmationPopover
      isDanger
      isOpen={isConfirmOpen}
      message="Are you sure you want to remove this user? They will immediately lose access to the Talent Hub."
      onClose={() => setIsConfirmOpen(false)}
      onPrimaryButtonClick={() => onDeactivate?.()}
      primaryButtonContent="Remove"
    >
      <span>{button}</span>
    </ConfirmationPopover>
  );
};
